/* tslint:disable */
import {
  Screen,
  KanvasUser,
  RotationItem
} from '../index';

declare var Object: any;
export interface ScreenCategoryInterface {
  "id": string;
  "name": string;
  "screenOrder"?: Array<any>;
  "kanvasUserId"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  screens?: Screen[];
  kanvasUser?: KanvasUser;
  childRotationItems?: RotationItem[];
  rotationItemsUsingThisCategory?: RotationItem[];
}

export class ScreenCategory implements ScreenCategoryInterface {
  "id": string;
  "name": string;
  "screenOrder": Array<any>;
  "kanvasUserId": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  screens: Screen[];
  kanvasUser: KanvasUser;
  childRotationItems: RotationItem[];
  rotationItemsUsingThisCategory: RotationItem[];
  constructor(data?: ScreenCategoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ScreenCategory`.
   */
  public static getModelName() {
    return "ScreenCategory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ScreenCategory for dynamic purposes.
  **/
  public static factory(data: ScreenCategoryInterface): ScreenCategory{
    return new ScreenCategory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ScreenCategory',
      plural: 'ScreenCategories',
      path: 'ScreenCategories',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "screenOrder": {
          name: 'screenOrder',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "kanvasUserId": {
          name: 'kanvasUserId',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        screens: {
          name: 'screens',
          type: 'Screen[]',
          model: 'Screen',
          relationType: 'hasMany',
          modelThrough: 'ScreenCategoryScreen',
          keyThrough: 'screenId',
          keyFrom: 'id',
          keyTo: 'screenCategoryId'
        },
        kanvasUser: {
          name: 'kanvasUser',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'kanvasUserId',
          keyTo: 'id'
        },
        childRotationItems: {
          name: 'childRotationItems',
          type: 'RotationItem[]',
          model: 'RotationItem',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'ownerScreenCategoryId'
        },
        rotationItemsUsingThisCategory: {
          name: 'rotationItemsUsingThisCategory',
          type: 'RotationItem[]',
          model: 'RotationItem',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'screenCategoryId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/ScreenCategory.ts